import { Component, Input } from '@angular/core';
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons';
import { IFilePageAndWords } from 'src/modules/shared/models/interfaces/files.interface';

@Component({
  selector: 'hcr-smart-canvas-ocr-status',
  templateUrl: './smart-canvas-ocr-status.component.html',
  styleUrls: ['./smart-canvas-ocr-status.component.sass']
})
export class SmartCanvasOcrStatusComponent {
  @Input() selectedFilePagesAndWords: IFilePageAndWords[] = [];

  public icons = {
    spinner: faCircleNotch,
  };
}
